import React, { useContext, useEffect, useState } from "react";
import PROFILE from "../assits/Profile.avif";

import { Link, useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { BASE_URL, UserContext } from "../contexts/UserContext";
import axios from "axios";
import ButtonLoader from "./ButtonLoader";


const Header = () => {

  const [loading, setLoading] = useState(false);
  const { isAuthenticated, setMessage, setError, currentUser } = useContext(UserContext);
  const navigate = useNavigate()

  const [windowSize, setWindowSize] = useState({
		width: window.innerWidth,
	});
  const [isNavShowing, setIsNavShowing] = useState(
    windowSize.width > 800 ? true : false
  );

  useEffect(() => {
		const handleResize = () => {
			setWindowSize({
				width: window.innerWidth,
			});
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);


  const closeNavHandler = () => {
    if (window.innerWidth < 800) {
      setIsNavShowing(false);
    } else {
      setIsNavShowing(true);
    }
  };
  const handleLogoutUser = async () => {
    try {
      setLoading(false);
      const { data } = await axios.get(`${BASE_URL}/users/logout`, { withCredentials: true });

      localStorage.setItem('user', null);
      setMessage(data?.message);
      setIsNavShowing(false);
      window.location.reload();
      navigate('/login');


    } catch (error) {
      setError(error.response.data.message);
      setIsNavShowing(false);

    }
  }

  return (
    <nav>
      <div className="container nav__container">
        <Link to={"/"} style={{ width: '3rem', height: '3rem', borderRadius: "50%" }} className="nav__logo" onClick={closeNavHandler}>
          <img style={{ borderRadius: "50%" }} src={ currentUser?.profile ? currentUser?.profile?.secure_url: PROFILE} alt="" />
        </Link>
        {isNavShowing && (
          <ul className="nav__menu">
            <li>
              <Link onClick={closeNavHandler} to={`/profile/${currentUser?._id}`}>
                {currentUser?.name}
              </Link>
            </li>
            <li>
              <Link onClick={closeNavHandler} to={"/create"}>
                Create Post
              </Link>
            </li>
            <li>
              <Link onClick={closeNavHandler} to={"/authors"}>
                Authors
              </Link>
            </li>
            <li>
              {isAuthenticated ? (
                <Link
                  className={window.innerWidth < 800 ? '' : "btn danger"}
                  onClick={() => handleLogoutUser()}
                >
                  {!loading ? "Logout" : <ButtonLoader />}
                </Link>
              ) : (
                <Link
                  to={'/login'}
                  className={window.innerWidth < 800 ? '' : "btn primary"}
                  onClick={() => closeNavHandler()}
                >
                  {!loading ? "Login" : <ButtonLoader />}
                </Link>
              )}
            </li>
          </ul>
        )}
        <button
          className="nav__toggle-btn"
          onClick={() => setIsNavShowing(!isNavShowing)}
        >
          {isNavShowing ? <AiOutlineClose /> : <FaBars />}
        </button>
      </div>
    </nav>
  );
};

export default Header;
